import dynamic from 'next/dynamic';

export const SustainabilityModalDynamic = dynamic(
  () => import('./SustainabilityModal.client').then((mod) => mod.SustainabilityModal),
  { ssr: false },
);
